import React, { useEffect, useState } from "react";
import image from "../../../assets/images/Current location-pana 1.png";
import { BsFilter } from "react-icons/bs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { Checkbox, FormControlLabel, Box } from "@mui/material";
import { Paper } from "@mui/material";
import classes from "./location.module.css";
import { Typography, TextField, InputAdornment, Divider } from "@mui/material";
import {
  locationStatusFilter,
  locationTimeFilter,
} from "../../../utilities/constants";
import { Button, Menu, MenuItem } from "@mui/material";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  authApi,
  getAuthorizationHeader,
} from "../../../api-calls/user-requests";
import {
  saveLocationList,
  saveLocationStatusFilter,
  saveLocationTimeFilter,
} from "../../../Redux/actions/location-action";
import { LOCATION, VERIFY_HOLIDAY } from "../../../api-calls/api-urls";

import { getLanguagedataFunction } from "../../../utilities/language";
import {
  ArrowDownIcon,
  DatePickerCalendarIcon,
  FilterIcon,
  RoundAddIcon,
  SearchIcon,
} from "../../../components/Icons";
import LocattionBoxContainer from "./LocattionBoxContainer";
import AlertBox from "../../../components/AlertBox";

const LocationIndex = () => {
  const navigate = useNavigate();
  const [serachValue, setSearchValue] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [error, setError] = useState("");
  const [anchorEl, setAnchorEl] = useState(null); // State to anchor the menu
  const [anchorEl1, setAnchorEl1] = useState(null);
  const [updateState, setUpdateState] = useState(); // State to anchor the menu
  const [selectedValues, setSelectedValues] = useState(() => {
    return ["all"];
  });
  const [selectedValues1, setSelectedValues1] = useState("newest_to_oldest"); // State to store selected values
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const [holiday, setHoliday] = useState(false);
  const [loading, setLoading] = useState(false);
  const togglesidebar = useSelector(
    (state) => state.allUsers.togglesidebar
  );
  const dispatch = useDispatch();
  const {
    locationList,
    locationFilteredStatus,
    locationFilterTime,
    locationFilterMembers,
    viewAll,
    totalcount,
  } = useSelector((state) => state.location);
  const { sortName } = useSelector((state) => state.allUsers);

  const ln = useSelector((state) => state.allUsers.language_json);

  React.useEffect(() => {
    getLanguagedataFunction(dispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!ln]);

  const handleClick = async () => {
    try {
      const { data } = await authApi.get(
        `${VERIFY_HOLIDAY}/${moment(new Date()).format("YYYY-MM-DD")}`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      if (!data.holiday) {
        navigate("/location/create-location");
      } else {
        setHoliday(true);
      }
    } catch (error) {
      console.log(error);
      setHoliday(true);
    }
  };

  useEffect(() => {
    // When the page loads, initialize the checkboxes state
    if (selectedValues.includes("all")) {
      dispatch(saveLocationStatusFilter(locationStatusFilter)); // Save all options
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (showAlert) {
      const timeout = setTimeout(() => {
        setShowAlert(false);
      }, 3000); // Change the duration (in milliseconds) as per your requirement

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [showAlert]);

  const handleMenuclick = (event, name) => {
    name(event.currentTarget);
  };

  const handleStatusCheckbox = (value) => {
    const isSelected = selectedValues.includes(value);

    if (value === "all") {
      if (isSelected) {
        // Unselect all checkboxes
        setSelectedValues([]);
        dispatch(saveLocationStatusFilter([]));
      } else {
        // Select all checkboxes
        setSelectedValues([...locationStatusFilter]);
        dispatch(saveLocationStatusFilter([...locationStatusFilter]));
      }
    } else {
      // Toggle the selection of individual checkboxes
      let newSelectedValues = [];

      if (isSelected) {
        newSelectedValues = selectedValues.filter((v) => v !== value);
      } else {
        newSelectedValues = [...selectedValues, value];
      }
      setSelectedValues(newSelectedValues);
      dispatch(saveLocationStatusFilter(newSelectedValues));

      const areAllSelected = locationStatusFilter
        .filter((item) => item !== "all")
        .every((item) => newSelectedValues.includes(item));

      // Check the "All" checkbox if all others are selected
      if (areAllSelected) {
        setSelectedValues((prevSelected) => [...prevSelected, "all"]);
        dispatch(saveLocationStatusFilter([...newSelectedValues, "all"]));
      } else {
        // Uncheck the "All" checkbox if any other checkbox is unselected
        setSelectedValues((prevSelected) =>
          prevSelected.filter((item) => item !== "all")
        );
        dispatch(
          saveLocationStatusFilter(
            newSelectedValues.filter((item) => item !== "all")
          )
        );
      }
    }
  };

  const handleTimeCheckBox = (value) => {
    setSelectedValues1(value);
    dispatch(saveLocationTimeFilter(value));
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setAnchorEl1(null);
  };

  const getLocationData = async (userEntry) => {
    setLoading(true);
    try {
      if (fromDate !== null && toDate !== null) {
        const { data } = await authApi.post(
          `${LOCATION}?sort=${sortName}&search=${serachValue}&start_date=${dayjs(
            fromDate
          ).format("YYYY-MM-DD")}&end_date=${dayjs(toDate).format(
            "YYYY-MM-DD"
          )}&view_all=${true}`,
          userEntry,
          {
            headers: { Authorization: getAuthorizationHeader() },
          }
        );
        dispatch(saveLocationList(data));
      } else {
        const { data } = await authApi.post(
          `${LOCATION}?sort=${sortName}&search=${serachValue}&view_all=${true}`,
          userEntry,
          {
            headers: { Authorization: getAuthorizationHeader() },
          }
        );
        dispatch(saveLocationList(data));
      }
    } catch (error) {
      setShowAlert(true);
      setError(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const filterArray = {
      status: locationFilteredStatus,
      sortby: locationFilterTime,
      members: locationFilterMembers,
    };
    console.log(filterArray);
    getLocationData(filterArray);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // eslint-disable-next-line react-hooks/exhaustive-deps
    !locationList,
    locationFilteredStatus,
    locationFilterTime,
    locationFilterMembers,
    fromDate,
    toDate,
    viewAll,
    serachValue,
    sortName,
    updateState,
  ]);

  return (
    <div>
      {ln && totalcount && totalcount > 0 ? (
        <div className={classes.indexpageMainBtn}>
          <Button
            variant="contained"
            style={{ textTransform: "none" }}
            onClick={() => handleClick()}
          >
            <RoundAddIcon style={{ marginRight: "10px" }} />
            {ln.assign_a_location}
          </Button>
        </div>
      ) : null}
      {ln && totalcount && totalcount > 0 ? (
        <div>
          <div
            className={`${classes.locationsmainDiv} ${classes.teampageMaindiv}`}
          >
            <div>
              <Box sx={{ mb: 2, mt: 0.5 }}>
                <TextField
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    width: togglesidebar ? "290px" : "360px",
                  }}
                  placeholder="search"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  className={classes.teamMemberSearch}
                  id="firstNameinput"
                  value={serachValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  size="small"
                />
              </Box>
            </div>
            <div
              style={{ display: "flex", columnGap: 10, alignItems: "center" }}
            >
              <div>
                <Button
                  variant="outlined"
                  className={classes.filterbtns}
                  onClick={(e) => handleMenuclick(e, setAnchorEl)}
                  style={{ background: "white" }}
                >
                  <div>
                    <BsFilter /> {ln.all}
                  </div>
                  <div>
                    <ArrowDownIcon />
                  </div>
                </Button>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                >
                  <Divider sx={{ my: 1 }} />
                  {locationStatusFilter.map((item, index) => (
                    <MenuItem key={`sort${index}`} sx={{ py: 0.5 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            checked={locationFilteredStatus?.includes(item)}
                            onChange={() => handleStatusCheckbox(item)}
                          />
                        }
                        label={(ln[item] || item)?.replaceAll("_", " ").toLowerCase()}
                        sx={{ textTransform: 'capitalize' }}
                      />
                    </MenuItem>
                  ))}
                </Menu>
              </div>
              <div>
                <Button
                  variant="outlined"
                  className={classes.filterbtns}
                  onClick={(e) => handleMenuclick(e, setAnchorEl1)}
                  style={{ background: "white" }}
                >
                  <div>
                    <FilterIcon />{" "}
                    {selectedValues1
                      ? selectedValues1?.replaceAll("_", " ")
                      : ln.newest_to_oldest}
                  </div>
                  <div style={{ marginLeft: "10px" }}>
                    <ArrowDownIcon />
                  </div>
                </Button>
                <Menu
                  anchorEl={anchorEl1}
                  open={Boolean(anchorEl1)}
                  onClose={handleMenuClose}
                >
                  <Divider sx={{ my: 1 }} />
                  {locationTimeFilter.map((item, index) => (
                    <MenuItem
                      key={`filter${index}`}
                      onClick={() => handleTimeCheckBox(item)}
                      sx={{ py: 0.5 }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            checked={selectedValues1?.includes(item)}
                            onClick={(e) => e.stopPropagation()}
                          />
                        }
                        label={ln[item]?.replaceAll("_", " ")}
                        sx={{ textTransform: 'capitalize' }}
                      />
                    </MenuItem>
                  ))}
                </Menu>
              </div>
              <div>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Box sx={{ display: 'flex', gap: 1, mb: 1, mt: 1 }}>
                    <DesktopDatePicker
                      label="From Date"
                      slots={{ openPickerIcon: DatePickerCalendarIcon }}
                      slotProps={{ textField: { size: 'small' } }}
                      value={fromDate}
                      onChange={(newValue) => setFromDate(newValue)}
                      format="DD/MM/YYYY"
                      sx={{ bgcolor: 'white' }}
                    />
                    <DesktopDatePicker
                      label="To Date"
                      slots={{ openPickerIcon: DatePickerCalendarIcon }}
                      slotProps={{ textField: { size: 'small' } }}
                      value={toDate}
                      onChange={(newValue) => setToDate(newValue)}
                      format="DD/MM/YYYY"
                      sx={{ bgcolor: 'white' }}
                    />
                  </Box>
                </LocalizationProvider>
              </div>
            </div>
          </div>
          <LocattionBoxContainer
            setUpdateState={setUpdateState}
            locationList={locationList}
            viewAll={viewAll}
            fromDate={fromDate}
            toDate={toDate}
            loading={loading}
          />
        </div>
      ) : (
        <Paper className={classes.CreateTeamindex}>
          {ln ? (
            <div className={classes.imagePagemaindiv}>
              <img
                src={image}
                alt="createTeam"
                className={classes.CreateTeamimage}
              />
              <Typography className={classes.imagePageText} variant="h5">
                {ln.no_location_data}
              </Typography>
              <Button
                variant="contained"
                className={`${classes.imagepagebtn} ${classes.noDataImagePAge}`}
                onClick={() => handleClick()}
              >
                <RoundAddIcon />
                <span style={{ marginLeft: "8px" }}>
                  {ln.assign_a_location}
                </span>
              </Button>
            </div>
          ) : null}
        </Paper>
      )}
      {showAlert && error && (
        <AlertBox type="error" message={error} stateName={setShowAlert} />
      )}
      {holiday && (
        <AlertBox
          type="error"
          message={"Marked as holiday."}
          stateName={setHoliday}
        />
      )}
    </div>
  );
};

export default LocationIndex;
